import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  data () {
    return {
      list: [], // 数据数组
      needPage: true, // 是否需要分页
      needQuery: true, // 是否在created就执行查询操作
      queryUrl: '', // 列表请求数据接口
      deleteUrl: '', // 删除数据url
      queryOneUrl: '', // 查询单条地址
      addOrUpdateUrl: '', // 新增或更新数据url
      addOrUpdateVisible: false, // 新增修改是否可见
      exportDataUrl: '', // 导出数据url
      exportFileName: '', // 导出文件名称
      downloadTemplateUrl: '', // 下载模板URL
      downloadTemplateName: '', // 下载模板名称
      orderColumn: '', // 排序列
      orderType: 'asc', // 正序为asc。倒序为desc
      query: {}, // 查询参数
      dataListLoading: false, // 加载中
      currentId: '', // 更新数据的id
      isUpdate: false, // 是否更新数据
      selectedRows: [], // 选中的所有数据
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      addOrUpdateForm: {},
      uploadHeader: {
        Authorization: storage.get(ACCESS_TOKEN)
      },
      selectedRowsList: []
    }
  },
  created () {
    if (this.needQuery) {
      this.queryList()
    }
  },
  methods: {
    // 正则不能输入小数点
    limitNumber (value) {
      if (typeof value === 'string') {
        return !isNaN(Number(value)) ? value.replace(/\./g, '') : 0
      } else if (typeof value === 'number') {
        return !isNaN(value) ? String(value).replace(/\./g, '') : 0
      } else {
        return 0
      }
    },
    queryList () {
      // console.info(this.dataForm)
      // 评分年份(决策分析应用)
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query
      }
      if (this.needPage) {
        this.pagination.current = 1
        params.page = this.pagination.current
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          this.dataListLoading = false
          // if (res.code !== 0) {
          //   this.dataList = []
          //   this.total = 0
          //   return this.$message.error(res.msg)
          // }
          // this.dataList = this.mixinViewModuleOptions.getDataListIsPage ? (this.mixinViewModuleOptions.getImgIsPage ? res.data.records : res.data.list) : res.data
          // this.total = parseInt(this.mixinViewModuleOptions.getDataListIsPage ? res.data.total : 0)
          if (this.needPage) {
            this.list = data.list || []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            console.log(this.list)
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    // 重置
    resetList () {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType
        }
        this.query = params
      } else {
        this.query = {}
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    _updateForm (real, data) {
      const keys = Object.keys(real)
      const dataKeys = Object.keys(data)
      const newObject = {}
      keys.map(key => {
        if (dataKeys.includes(key)) {
          newObject[key] = data[key]
        } else {
          newObject[key] = real[key]
        }
      })
      return newObject
    },
    pageChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.pageQueryList()
    },
    pageQueryList () {
      // console.info(this.dataForm)
      // 评分年份(决策分析应用)
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query
      }
      if (this.needPage) {
        params.page = this.pagination.current
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            console.log(this.list)
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    addOrUpdateHandle (id) {
      this.isUpdate = false
      this.currentId = id
      console.log(this.$refs.addOrUpdateForm)
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.isUpdate = true
          this.$http.get(`${this.queryOneUrl}/${this.currentId}`).then(({ data }) => {
            console.log(data)
            console.log(this._updateForm(this.addOrUpdateForm, data))
            this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
          }).catch(() => {
          })
        }
      })
    },
    handleOk (e) {
      e.preventDefault()
      console.log(this.$refs.addOrUpdateForm)
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, this.query.sysType ? { id: this.currentId, sysType: this.query.sysType, ...this.addOrUpdateForm } : { id: this.currentId, ...this.addOrUpdateForm }
          )
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {
            })
        }
      })
    },
    handleCancel () {
      this.$refs.addOrUpdateForm.resetFields()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRows = selectedRowKeys
      this.selectedRowsList = selectedRows
    },
    deleteSelectRow () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          _this.$http.delete(_this.deleteUrl, { 'data': _this.selectedRows }).then((res) => {
            if (res.code === 0) {
              _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
              _this.queryList()
            }
          })
            .catch(() => {
            })
        },
        onCancel () {
          _this.selectedRows = []
          _this.$message.info('已取消删除')
        }
      })
    },
    // 导出
    exportHandle () {
      const token = storage.get(ACCESS_TOKEN)
      const params = {
        responseType: 'arraybuffer',
        params: this.query,
        headers: {
          'Authorization': token
        }
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      axios.get(url, params).then((res) => {
        console.log(res)
        const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
        const fileName = this.exportFileName || '导出数据.xlsx'
        const eLink = document.createElement('a')
        eLink.download = fileName
        eLink.style.display = 'none'
        eLink.href = URL.createObjectURL(blob)
        document.body.appendChild(eLink)
        eLink.click()
        URL.revokeObjectURL(eLink.href)
        document.body.removeChild(eLink)
        this.$message.success('导出完成')
      }).catch(() => {
      })
    },
    // 导出
    downloadTemplate (queryParms) {
      const token = storage.get(ACCESS_TOKEN)
      const params = {
        params: queryParms,
        responseType: 'arraybuffer',
        headers: {
          'Authorization': token
        }

      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.downloadTemplateUrl}`
      axios.get(url, params).then((res) => {
        console.log(res)
        const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
        const fileName = this.downloadTemplateName || '导入模板.xlsx'
        const eLink = document.createElement('a')
        eLink.download = fileName
        eLink.style.display = 'none'
        eLink.href = URL.createObjectURL(blob)
        document.body.appendChild(eLink)
        eLink.click()
        URL.revokeObjectURL(eLink.href)
        document.body.removeChild(eLink)
      }).catch(() => {
      })
    }
  }
}
